import classNames from 'classnames';
import { ComponentType, GetPageComponentViewModel } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { BANNERS_HEIGHT, elementTrackingId } from './contants';
import { useDataLayerPush } from '../../_utils/use-datalayer-push';
import { deviceTypeClassGenerator } from '../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
}
function CarouselBrand({
  data,
  isLazy
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const banner = data?.items?.[0];
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    const index = data?.type === ComponentType.SmallBanner ? 1 : 0;
    pushToDataLayer({
      event: elementTrackingId,
      elementType: data.type || '',
      elementIndex: index,
      itemID: banner?.id || '',
      elementName: data?.sortKey,
      destinationUrl: banner?.link || '',
      componentId: data?.id,
      ImageUrl: isMobile ? banner?.mobileImageUrl : banner?.desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: data.type || '',
      banner_name: data?.sortKey ?? '',
      banner_index: `${index}`,
      url_destination: banner?.link || '',
      item_id: banner?.id || '',
      component_id: data?.id ?? '',
      image_url: isMobile ? banner?.mobileImageUrl : banner?.desktopImageUrl
    });
  };
  if (!data.deviceTypes) return null;
  let height;
  if (data.type === ComponentType.SmallBanner || data.type === ComponentType.Banner) height = isMobile ? BANNERS_HEIGHT.mobile[data.type] : BANNERS_HEIGHT.desktop[data.type];
  return <AppNextLink href={banner?.link || ''} prefetch={false} aria-label={banner?.title || ''} onClick={handleClick} className={classNames('homepage-container', deviceTypeClassGenerator(data?.deviceTypes || ''))} data-sentry-element="AppNextLink" data-sentry-component="CarouselBrand" data-sentry-source-file="banner.tsx">
            <picture className='flex h-full' data-sentry-element="picture" data-sentry-source-file="banner.tsx">
                <source media='(min-width: 1024px)' srcSet={banner?.desktopImageUrl} />
                <LazyImage src={banner?.mobileImageUrl || ''} alt={banner?.title || 'بنر هوم پیج'} className={classNames('w-full rounded', {
        'max-h-[110px] object-cover': data.type === ComponentType.SmallBanner
      })} loaderClassName='h-40 lg:h-56' isLazy={isLazy} height={height} data-sentry-element="LazyImage" data-sentry-source-file="banner.tsx" />
            </picture>
        </AppNextLink>;
}
export default CarouselBrand;